<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputWithBlockLabel from "../../Form/Survey/VInputWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";
import VMulti from "../../Form/Survey/VMulti.vue";
import VInputReadonlyWithBlockLabel from "../../Form/Survey/VInputReadonlyWithBlockLabel.vue";
import VMultiShow from "../../Form/Survey/VMultiShow.vue";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    what_is_your_main_purpose_of_your_travel:
        answers?.what_is_your_main_purpose_of_your_travel ?? [],
    travel_companion: answers?.travel_companion ?? [],
    what_was_the_main_attraction_for_the_destinations_visited:
        answers?.what_was_the_main_attraction_for_the_destinations_visited ??
        [],
    where_did_you_stay_during_this_trip:
        answers?.where_did_you_stay_during_this_trip ?? [],
    how_many_nights_did_you_spend_at_the_destination:
        answers?.how_many_nights_did_you_spend_at_the_destination,
    where_did_you_travel_from: answers?.where_did_you_travel_from,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VInputReadonlyWithBlockLabel
                        elId="where_did_you_travel_from"
                        v-model:value="form.where_did_you_travel_from"
                        :label="surveyFields['where_did_you_travel_from']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithBlockLabel
                        elId="what_is_your_main_purpose_of_your_travel"
                        v-model:value="
                            form.what_is_your_main_purpose_of_your_travel
                        "
                        :label="
                            surveyFields[
                                'what_is_your_main_purpose_of_your_travel'
                            ]?.name
                        "
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VMultiShow
                        elId="travel_companion"
                        v-model:value="form.travel_companion"
                        :label="surveyFields['travel_companion']?.name"
                        :options="form.travel_companion"
                    />
                </div>

                <div class="mb-3">
                    <VMultiShow
                        elId="what_was_the_main_attraction_for_the_destinations_visited"
                        v-model:value="
                            form.what_was_the_main_attraction_for_the_destinations_visited
                        "
                        :label="
                            surveyFields[
                                'what_was_the_main_attraction_for_the_destinations_visited'
                            ]?.name
                        "
                        :options="
                            form.what_was_the_main_attraction_for_the_destinations_visited
                        "
                    />
                </div>

                <div class="mb-3">
                    <VMultiShow
                        elId="where_did_you_stay_during_this_trip"
                        v-model:value="form.where_did_you_stay_during_this_trip"
                        :label="
                            surveyFields['where_did_you_stay_during_this_trip']
                                ?.name
                        "
                        :options="form.where_did_you_stay_during_this_trip"
                    />
                </div>
                <div class="mb-3">
                    <VInputReadonlyWithBlockLabel
                        elId="how_many_nights_did_you_spend_at_the_destination"
                        v-model:value="
                            form.how_many_nights_did_you_spend_at_the_destination
                        "
                        :label="
                            surveyFields[
                                'how_many_nights_did_you_spend_at_the_destination'
                            ]?.name
                        "
                        :isPlainText="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
